// import React, { useState, useEffect } from 'react';
// import logo from '../Images/SGI-removebg-preview.png';
// import makemyindialogo from '../Images/makemyindia.png';
// import iaflogo from '../Images/IAF_Logo.png';
// import isologo from '../Images/ISO-9001-2015-certification.png';

// const MainscreenHeader = ({ onNavClick, activeSection }) => {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

//   const navItems = ['Home', 'Product', 'About', 'Contact'];

//   // Listen for screen resize
//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth <= 768);
//       if (window.innerWidth > 768) {
//         setMenuOpen(false); // Close menu if switching to desktop
//       }
//     };
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   return (
//     <div style={styles.header}>
//       {/* Left Logo */}
//       <div style={styles.leftSection}>
//         <img src={logo} alt="Company Logo" style={styles.logo} />
//       </div>

//       {/* Hamburger for Mobile */}
//       {isMobile && (
//         <div
//           style={styles.hamburger}
//           onClick={() => setMenuOpen(!menuOpen)}
//         >
//           ☰
//         </div>
//       )}

//       {/* Center Nav */}
//       <div
//         style={{
//           ...styles.centerSection,
//           ...(isMobile
//             ? {
//               display: menuOpen ? 'flex' : 'none',
//               flexDirection: 'column',
//               position: 'absolute',
//               top: '80px',
//               left: 0,
//               width: '100%',
//               background: 'white',
//               padding: '10px 0',
//               borderBottom: '2px solid orange',
//             }
//             : {}),
//         }}
//       >
//         {navItems.map((item) => (
//           <span
//             key={item}
//             style={{
//               ...styles.navItem,
//               borderBottom:
//                 activeSection === item.toLowerCase()
//                   ? '2px solid #ff6500'
//                   : 'none',
//               color:
//                 activeSection === item.toLowerCase() ? '#ff6500' : '#333',
//             }}
//             onClick={() => {
//               onNavClick(item.toLowerCase());
//               setMenuOpen(false);
//             }}
//           >
//             {item}
//           </span>
//         ))}
//       </div>

//       {/* Right Logos */}
//       <div
//         style={{
//           ...styles.rightSection,
//           ...(isMobile ? styles.rightSectionMobile : {})
//         }}
//       >
//         <img
//           src={makemyindialogo}
//           alt="makeinindia"
//           style={{
//             ...styles.iconLogo,
//             ...(isMobile ? styles.iconLogoMobile : {})
//           }}
//         />
//         <img
//           src={iaflogo}
//           alt="iaf"
//           style={{
//             ...styles.iconLogo,
//             ...(isMobile ? styles.iconLogoMobile : {})
//           }}
//         />
//         <img
//           src={isologo}
//           alt="iso"
//           style={{
//             ...styles.iconLogo,
//             ...(isMobile ? styles.iconLogoMobile : {})
//           }}
//         />
//       </div>

//     </div>
//   );
// };

// const styles = {
//   header: {
//     position: 'fixed',
//     top: 0,
//     left: 0,
//     width: '100%',
//     height: '80px',
//     background: 'white',
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     padding: '0 20px',
//     zIndex: 1000,
//     borderBottom: '4px solid orange',
//   },
//   leftSection: {
//     width: '35%',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'flex-start',
//   },
//   centerSection: {
//     width: '40%',
//     // background:"red",
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     color: '#ff6500',
//     fontWeight: 'bold',
//     flexWrap: 'wrap',
//     gap: '7px',
//   },
//   navItem: {
//     cursor: 'pointer',
//     fontSize: '16px',
//     fontWeight: 'bold',
//     color: '#ff6500',
//     transition: 'color 0.3s ease',
//   },
//   rightSection: {
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     gap: '10px',
//     flexWrap: 'wrap', // allow wrapping
//     width: '30%',
//   },
//   iconLogo: {
//     width:'40px',
//     maxWidth: '60px',
//     height: 'auto',
//   },
//   // Mobile styles
//   rightSectionMobile: {
//     width: '100%',
//     justifyContent: 'center',
//     marginTop: '10px',
//   },
//   iconLogoMobile: {
//     maxWidth: '45px',
//     height: 'auto',
//   },
//   logo: {
//     height: 'auto',
//     maxHeight: '110px',
//     width: 'auto',
//     maxWidth: '100%',
//     objectFit: 'contain',
//   },

//   hamburger: {
//     fontSize: '28px',
//     cursor: 'pointer',
//   },
// };

// export default MainscreenHeader;



import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

import logo from '../Images/logo.png';
import makemyindialogo from '../Images/makemyindia.png';
import iaflogo from '../Images/IAF_Logo.png';
import isologo from '../Images/ISO-9001-2015-certification.png';

const MainscreenHeader = ({ onNavClick, activeSection }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [scrolled, setScrolled] = useState(false);
  const [hoveredNav, setHoveredNav] = useState(null);

  const navItems = ['Home', 'Product', 'About', 'Contact'];

  /* ---------------------------------------
     RESPONSIVE SCREEN
  --------------------------------------- */
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;

      setIsMobile(mobile);

      if (!mobile) {
        setMenuOpen(false);
      }
    };

    const handleScroll = () => {
      setScrolled(window.scrollY > 15);
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  /* ---------------------------------------
     NAVIGATION
  --------------------------------------- */
  const handleNavigation = (item) => {
    const section = item.toLowerCase();

    onNavClick(section);
    setMenuOpen(false);
  };

  return (
    <>
      {/* =====================================
          HEADER
      ====================================== */}
      <motion.header
        initial={{ y: -100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{
          duration: 0.7,
          ease: [0.22, 1, 0.36, 1],
        }}
        style={{
          ...styles.header,
          ...(scrolled ? styles.headerScrolled : {}),
        }}
      >

        {/* =====================================
            LEFT - COMPANY LOGO
        ====================================== */}
        <div style={styles.leftSection}>

          <motion.img
            src={logo}
            alt="StructGuard Infra Products & Services"
            style={styles.logo}
            whileHover={{
              scale: 1.04,
            }}
            transition={{
              duration: 0.25,
            }}
          />

        </div>


        {/* =====================================
            DESKTOP NAVIGATION
        ====================================== */}
        {!isMobile && (
          <nav style={styles.centerSection}>

            {navItems.map((item) => {
              const section = item.toLowerCase();
              const isActive = activeSection === section;

              return (
                <motion.div
                  key={item}
                  style={styles.navWrapper}
                  onMouseEnter={() => setHoveredNav(item)}
                  onMouseLeave={() => setHoveredNav(null)}
                  onClick={() => handleNavigation(item)}
                  whileTap={{ scale: 0.95 }}
                >

                  <span
                    style={{
                      ...styles.navItem,
                      color:
                        isActive || hoveredNav === item
                          ? '#f26b21'
                          : '#27323a',
                    }}
                  >
                    {item}
                  </span>

                  {/* Animated underline */}
                  <motion.div
                    initial={false}
                    animate={{
                      width:
                        isActive || hoveredNav === item
                          ? '100%'
                          : '0%',
                    }}
                    transition={{
                      duration: 0.25,
                      ease: 'easeOut',
                    }}
                    style={styles.navUnderline}
                  />

                </motion.div>
              );
            })}

          </nav>
        )}


        {/* =====================================
            RIGHT CERTIFICATION LOGOS
        ====================================== */}
        <div
          style={{
            ...styles.rightSection,
            ...(isMobile ? styles.rightSectionMobile : {}),
          }}
        >

          <LogoBadge
            image={makemyindialogo}
            alt="Make in India"
          />

          <LogoBadge
            image={iaflogo}
            alt="IAF"
          />

          <LogoBadge
            image={isologo}
            alt="ISO 9001:2015"
          />

        </div>


        {/* =====================================
            MOBILE HAMBURGER
        ====================================== */}
        {isMobile && (
          <motion.button
            onClick={() => setMenuOpen(!menuOpen)}
            style={styles.menuButton}
            whileTap={{ scale: 0.88 }}
            aria-label="Toggle navigation"
          >

            <span
              style={{
                ...styles.menuLine,
                transform: menuOpen
                  ? 'rotate(45deg) translate(5px, 5px)'
                  : 'rotate(0)',
              }}
            />

            <span
              style={{
                ...styles.menuLine,
                opacity: menuOpen ? 0 : 1,
              }}
            />

            <span
              style={{
                ...styles.menuLine,
                transform: menuOpen
                  ? 'rotate(-45deg) translate(5px, -5px)'
                  : 'rotate(0)',
              }}
            />

          </motion.button>
        )}

      </motion.header>


      {/* =====================================
          MOBILE NAVIGATION
      ====================================== */}
      <AnimatePresence>
        {isMobile && menuOpen && (

          <motion.div
            initial={{
              opacity: 0,
              y: -20,
            }}
            animate={{
              opacity: 1,
              y: 0,
            }}
            exit={{
              opacity: 0,
              y: -20,
            }}
            transition={{
              duration: 0.3,
              ease: 'easeOut',
            }}
            style={styles.mobileMenu}
          >

            {navItems.map((item, index) => {

              const section = item.toLowerCase();
              const isActive = activeSection === section;

              return (
                <motion.div
                  key={item}
                  initial={{
                    opacity: 0,
                    x: -15,
                  }}
                  animate={{
                    opacity: 1,
                    x: 0,
                  }}
                  transition={{
                    delay: index * 0.06,
                  }}
                  onClick={() => handleNavigation(item)}
                  style={{
                    ...styles.mobileNavItem,
                    color: isActive
                      ? '#f26b21'
                      : '#27323a',
                    background: isActive
                      ? '#fff5ee'
                      : 'transparent',
                  }}
                  whileHover={{
                    x: 5,
                    background: '#fff5ee',
                    color: '#f26b21',
                  }}
                  whileTap={{
                    scale: 0.98,
                  }}
                >

                  <span>{item}</span>

                  <span style={styles.mobileArrow}>
                    →
                  </span>

                </motion.div>
              );
            })}

          </motion.div>

        )}
      </AnimatePresence>
    </>
  );
};


/* =========================================
   CERTIFICATION LOGO COMPONENT
========================================= */

const LogoBadge = ({ image, alt }) => {

  return (
    <motion.div
      style={styles.logoBadge}
      whileHover={{
        y: -3,
        scale: 1.06,
      }}
      transition={{
        duration: 0.25,
      }}
    >

      <img
        src={image}
        alt={alt}
        style={styles.certificationLogo}
      />

    </motion.div>
  );
};


/* =========================================
   INLINE STYLES
========================================= */

const styles = {

  /* ---------------------------------------
     MAIN HEADER
  --------------------------------------- */

  header: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '78px',

    display: 'flex',
    alignItems: 'center',

    background: 'rgba(255,255,255,0.96)',
    backdropFilter: 'blur(14px)',
    WebkitBackdropFilter: 'blur(14px)',

    padding: '0 28px',
    boxSizing: 'border-box',

    zIndex: 1000,

    borderBottom: '1px solid rgba(230,230,230,0.8)',

    transition:
      'box-shadow 0.3s ease, background 0.3s ease',
  },


  headerScrolled: {
    background: 'rgba(255,255,255,0.98)',

    boxShadow:
      '0 8px 30px rgba(0,0,0,0.07)',
  },


  /* ---------------------------------------
     LEFT LOGO
  --------------------------------------- */

  leftSection: {
    width: '30%',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',

    minWidth: 0,
  },


  logo: {
    height: '80px',
    width: 'auto',

    maxWidth: '220px',

    objectFit: 'contain',

    cursor: 'pointer',

    display: 'block',
  },


  /* ---------------------------------------
     DESKTOP NAV
  --------------------------------------- */

  centerSection: {
    width: '40%',

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    gap: '42px',
  },


  navWrapper: {
    position: 'relative',

    padding:
      '27px 2px 23px 2px',

    cursor: 'pointer',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },


  navItem: {
    fontSize: '15px',

    fontWeight: '600',

    letterSpacing: '0.2px',

    transition:
      'color 0.25s ease',

    userSelect: 'none',
  },


  navUnderline: {
    position: 'absolute',

    bottom: '17px',
    left: 0,

    height: '2px',

    width: '0%',

    background:
      'linear-gradient(90deg, #f26b21, #ff9b62)',

    borderRadius: '10px',
  },


  /* ---------------------------------------
     RIGHT LOGOS
  --------------------------------------- */

  rightSection: {
    width: '30%',

    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',

    gap: '9px',
  },


  logoBadge: {
    width: '44px',
    height: '44px',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    background: '#ffffff',

    border:
      '1px solid #eeeeee',

    borderRadius: '10px',

    boxShadow:
      '0 3px 12px rgba(0,0,0,0.04)',

    cursor: 'pointer',

    overflow: 'hidden',
  },


  certificationLogo: {
    width: '34px',
    height: '34px',

    objectFit: 'contain',
  },


  /* ---------------------------------------
     MOBILE BUTTON
  --------------------------------------- */

  menuButton: {
    width: '42px',
    height: '42px',

    border: 'none',
    background: '#fff',

    borderRadius: '10px',

    display: 'flex',
    flexDirection: 'column',

    alignItems: 'center',
    justifyContent: 'center',

    gap: '5px',

    cursor: 'pointer',

    padding: 0,

    boxShadow:
      '0 3px 12px rgba(0,0,0,0.06)',
  },


  menuLine: {
    width: '22px',
    height: '2px',

    background: '#27323a',

    borderRadius: '10px',

    transition:
      'all 0.25s ease',
  },


  /* ---------------------------------------
     MOBILE CERTIFICATION LOGOS
  --------------------------------------- */

  rightSectionMobile: {
    width: 'auto',

    marginLeft: 'auto',
    marginRight: '10px',

    gap: '5px',
  },


  /* ---------------------------------------
     MOBILE MENU
  --------------------------------------- */

  mobileMenu: {
    position: 'fixed',

    top: '78px',
    left: '0',

    width: '100%',

    background: '#ffffff',

    padding: '10px 18px 18px 18px',

    boxSizing: 'border-box',

    zIndex: 999,

    borderBottom:
      '1px solid #eeeeee',

    boxShadow:
      '0 15px 30px rgba(0,0,0,0.08)',

    display: 'flex',

    flexDirection: 'column',

    gap: '5px',
  },


  mobileNavItem: {
    width: '100%',

    padding: '14px 16px',

    boxSizing: 'border-box',

    borderRadius: '10px',

    display: 'flex',

    alignItems: 'center',

    justifyContent: 'space-between',

    fontSize: '15px',

    fontWeight: '600',

    cursor: 'pointer',

    transition:
      'background 0.25s ease, color 0.25s ease',
  },


  mobileArrow: {
    fontSize: '18px',

    color: '#f26b21',

    fontWeight: '500',
  },

};

export default MainscreenHeader;
